export const pagePath = {
  landing: '/',
  home: '/home',
  login: '/login',
  signup: '/signup',
  confirmSignup: '/confirm-signup',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',
  invite: '/invite/:token',
  sign: '/sign/:token',
  publicLeadForm: '/f/:token',
  publicGallery: '/g/:token',
  clientPortal: '/p/:token',
  tenant: {
    create: '/tenant/create',
    choose: '/tenant/choose',
  },
  lead: {
    list: '/leads',
    detail: '/leads/:leadId',
  },
  event: {
    list: '/event',
  },
  todo: {
    list: '/todos',
  },
  catalog: {
    list: '/catalog',
  },
  contractTemplate: {
    list: '/contract-templates',
  },
  settings: '/settings',
  billing: '/billing',
  planChoice: '/plan-choice',
  team: '/team',
  reports: '/reports',
  statistics: '/statistics',
};

export const leadDetailPath = (leadId: string): string => `/leads/${leadId}`;

export const inviteWithToken = (token: string): string => `/invite/${token}`;

export const signWithToken = (token: string): string => `/sign/${token}`;

export const publicLeadFormWithToken = (token: string): string => `/f/${token}`;

export const publicGalleryWithToken = (token: string): string => `/g/${token}`;

export const clientPortalWithToken = (token: string): string => `/p/${token}`;
